module.exports = __webpack_public_path__ + "static/media/clouds-sun.046b9340.svg";